import React, { useEffect, useState } from "react";
import { Alert, Button, Snackbar } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



export function AlertDialog({ onOk, title, message, children: Element }) {
  const [open, setOpen] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div
        onClick={handleClickOpen}
      >
        {Element}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { handleClose(); onOk(); }}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function AlertDlg2({title="??", error, onOk = () => {}}) {
  const [open,setOpen]=useState();
  const [msg,setMsg]=useState(error);
  useEffect(()=>{
    setOpen(!!error);
    if (!!error) {
      setMsg(error)
    }
  },[error])
  function handleClose() {
    setOpen(false);
  }
 return <Dialog
  open={!!open}
  onClose={handleClose}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
      {msg}
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => {
        handleClose();
        onOk();
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>
}

export function Notify({ notify, onOk, error}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(notify);
  // console.log({error, msg})
  useEffect(() => {
    setOpen(!!notify);
    if (!!notify) {
      setMsg(notify)
    }
  }, [notify])
  function handleClose() {
    setOpen(false);
    onOk && onOk();
  }
  return <Snackbar
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    open={open}
    autoHideDuration={6000}
    onClose={handleClose}
  >
    <Alert
      onClose={handleClose}
      severity={error ? "error" : "success"}
      sx={{ width: "100%", whiteSpace: 'pre-line' }}
    >
      {error ? `Error!\n${msg}` : `Successfull!\n${msg}`}
    </Alert>
  </Snackbar>
}

export function ConfirmDlg({question, onOk = () => {}, onCancel = ()=>{}}) {
  const [open,setOpen]=useState();
  const [msg,setMsg]=useState(question);
  useEffect(()=>{
    setOpen(!!question);
    if (!!question) {
      setMsg(question)
    }
  },[question])
  function handleClose() {
    setOpen(false);
  }
 return <Dialog
  open={!!open}
  onClose={handleClose}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogTitle id="alert-dialog-title">{"??"}</DialogTitle>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
      {msg}
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => {
        handleClose();
        onOk();
      }}
    >
      {"OK"}
    </Button>
    <Button
      onClick={() => {
        handleClose();
        onCancel();
      }}
    >
      {"?????"}
    </Button>
  </DialogActions>
</Dialog>
}